//import GroupReferralViewV2 from './GroupReferralViewV2';
import ProductView from './ProductView';
import QuickBIView from './QuickBIView';
import auth from '../Service/AuthFetchService';

import { BrowserRouter as Router, Link, Route, Redirect } from 'react-router-dom';
import React from 'react';
import { Layout, Menu, Button } from 'antd';
import { AreaChartOutlined, LaptopOutlined, LineChartOutlined, MenuOutlined, ProjectOutlined, CompassOutlined, ShoppingOutlined, DotChartOutlined, GlobalOutlined, TeamOutlined, RiseOutlined, ToolOutlined, BarChartOutlined, RocketOutlined} from '@ant-design/icons';

const { SubMenu } = Menu;
const { Content, Sider } = Layout;


// https://home.baicizhan.com/login?service=https%3A%2F%2Ftech-brain.baicizhan.com
class FormView extends React.Component {

    pathToView = {
        //'/forms/group_referral': 'GroupReferralViewV2',
        '/forms/bcz_core': 'BczCoreView',
        '/forms/universal_core': 'UniversalCoreView',
        '/forms/nocturne_core': 'NocturneCoreView',
        '/forms/old_group_referral': 'GroupReferralView',
        '/forms/full_referral': 'FullReferralView',
        '/forms/bcz_referral': 'BczReferralView',
        '/forms/mintpie_referral': 'MintpieReferralView',
        '/forms/mintpie_wx_app': 'MintpieWxAppView',
        '/forms/ec_referral': 'ECReferralView',
        '/forms/ad_tracing': 'AdTracinglView',
        '/forms/new_user_referral_30d': 'NewUserReferral30DlView',
        '/forms/finance': 'FinanceView',
        '/forms/datap_access': 'DataPAccessView',
        '/forms/bi_access': 'BIAccessView',
        '/forms/group_realtime': 'GroupRealtimeView',
        '/forms/group_daily': 'GroupDailyView',
        '/forms/group_weekly': 'GroupWeeklyView',
        '/forms/group_monthly': 'GroupMonthlyView',
        '/forms/group_year': 'GroupYearView',
        '/forms/real_product': 'RealProductView',
        '/forms/user_life_cycle': 'UserLifeCycle',
        '/forms/rt_storage_all': 'RtStorageAllView',
        '/forms/rt_storage_mintpie': 'RtStorageMintpieView',
        '/forms/rt_storage_bcz': 'RtStorageBczView',
        '/forms/kol_monitor': 'KOLMonitorView',
        '/forms/future_core': 'FutureCoreView',
        '/forms/order_query': 'OrderQueryView',
        '/forms/no_order_monitor': 'NoOrderMonitorView',
        '/forms/activity_data': 'ActivityDataView',
        '/forms/bcz_yuqing': 'BczYuqingView',
        '/forms/mintpie_yuqing': 'MintpieYuqingView',
        '/forms/future_yuqing': 'FutureYuqingView',
        '/forms/strategy_yuqing': 'StrategyYuqingView',
        '/forms/ad_recommend_monitor': 'AdRecommendView',
        '/forms/hr_group': 'hrGroupView',
        '/forms/hr_group_cost': 'hrGroupCostView',
        '/forms/bcz_retention': 'BczRetentionView',
        '/forms/sku_satisfaction': 'SkuSatisfactionView',
        '/forms/credit_data': 'CreditDataView',
        '/forms/bcz_user_profile': 'BczUserProfileView',
    }

    static clientDeltaY = 120

    constructor() {
        super();
        const path = window.location.pathname;
        const view = this.pathToView[path];
        this.state = {
            collapsed: true,
            currentView: view === undefined ? 'GroupRealtimeView' : view,
            clientHeight: document.body.clientHeight - FormView.clientDeltaY,
        };
    }

    componentDidMount() {
        window.onresize = () => {
            this.setState({ clientHeight: document.body.clientHeight - FormView.clientDeltaY });
        }
    }

    componentWillUnmount() {
        delete window.onresize;
    }

    // collapseSider() {
    //     this.setState({ collapsed: !this.state.collapsed });
    // }

    iFrameDidLoad = () => {
        let ifm = document.getElementById("FinanceView");
        ifm.height = document.documentElement.clientHeight;
    }

    render() {
        return (
            <Router basename="/forms">
                <Layout
                    className="site-layout-background"
                    style={{ padding: '24px 0', position: 'relative' }}
                    hidden={this.props.hidden}
                >
                    <Sider
                        className="site-layout-background"
                        width={220}
                        theme={"light"}
                        collapsed={this.state.collapsed}
                        style={{
                            height: this.state.clientHeight,
                            overflowY: 'auto',
                            position: 'absolute',
                            zIndex: 100
                        }}
                        onMouseEnter={() => this.setState({ collapsed: false })}
                        onMouseLeave={() => this.setState({ collapsed: true })}
                    >
                        <Menu
                            mode="inline"
                            //defaultSelectedKeys={[this.state.currentView]}
                            //defaultOpenKeys={['Bcz', 'GroupReferral', 'Finance', 'Group', 'RealProduct', 'GenericForms', 'NoOrderMonitor']}
                            selectedKeys={[this.state.currentView]}
                            onSelect={(item) => this.setState({ currentView: item.key })}
                            style={{ height: '100%' }}
                        >
                            {/* <Button size="middle" icon={<MenuOutlined />} onClick={this.collapseSider.bind(this)}
                                style={{
                                    color: "#000000",
                                    border: "none",
                                    margin: "0px 0px 0px 15px"
                                }}
                            /> */}
                            {(auth.prefix('datap:form:group_') || auth.allow('datap:form:kol_monitor')) && <>
                                <SubMenu key="Group" icon={<AreaChartOutlined />} title="集团大盘">
                                    {auth.allow('datap:form:group_realtime') &&
                                        <Menu.Item key="GroupRealtimeView">
                                            <Link to="/group_realtime">实时大盘</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:group_daily') &&
                                        <Menu.Item key="GroupDailyView">
                                            <Link to="/group_daily">集团日报</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:group_weekly') &&
                                        <Menu.Item key="GroupWeeklyView">
                                            <Link to="/group_weekly">集团周报</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:group_monthly') &&
                                        <Menu.Item key="GroupMonthlyView">
                                            <Link to="/group_monthly">集团月报</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:group_year') &&
                                        <Menu.Item key="GroupYearView">
                                            <Link to="/group_year">集团年报</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:kol_monitor') &&
                                        <Menu.Item key="KOLMonitorView">
                                            <Link to="/kol_monitor">KOL投放监控</Link>
                                        </Menu.Item>}
                                </SubMenu>
                            </>}
                            {auth.prefix('datap:form:') && <>
                                {/* <SubMenu key="Bcz" icon={<CompassOutlined />} title="业务报表"> */}
                                    <SubMenu key="FC" icon={<BarChartOutlined />} title="大营收多SKU">
                                        {auth.prefix('datap:form:fc_overview') &&
                                        <Menu.Item key="FCOverview">
                                        <Link to="/fc_overview">总览</Link>
                                        </Menu.Item>}
                                        {(auth.allow('datap:form:mintpie_analyse_self_flow') || auth.allow('datap:form:mintpie_analyse_tomato') || auth.allow('datap:form:adult_english') || auth.allow('datap:form:newreading_core')) &&
                                            <SubMenu key="MintPie" title="大学及成人英语">
                                                {auth.allow('datap:form:adult_english') &&
                                                    <Menu.Item key="AdultEnglishView">
                                                    <Link to="/adult_english">核心报表</Link>
                                                </Menu.Item>}
                                                {auth.allow('datap:form:mintpie_analyse_self_flow') && <Menu.Item key="MintpieAnaSelfFlowView">
                                                    <Link to="/mintpie_analyse_self_flow">SKU流量</Link>
                                                </Menu.Item>}
                                                {auth.allow('datap:form:mintpie_analyse_tomato') && <Menu.Item key="MintpieAnaTomatolView">
                                                    <Link to="/mintpie_analyse_tomato">番茄</Link>
                                                </Menu.Item>}
                                                {auth.allow('datap:form:newreading_core') && <Menu.Item key="NewreadingCoreView">
                                                    <Link to="/newreading_core">新阅读</Link>
                                                </Menu.Item>}
                                            </SubMenu>}

                                            {(auth.allow('datap:form:future_core') || auth.allow('datap:form:college_math_core')) &&
                                            <SubMenu key="FutureView" title="未来技能">
                                                {auth.allow('datap:form:future_core') &&
                                                <Menu.Item key="FutureCoreView">
                                                    <Link to="/future_core">核心报表</Link>
                                                </Menu.Item>}
                                            </SubMenu>}

                                            {(auth.prefix('datap:form:k12_') || auth.allow('datap:form:mintpie_analyse_nce')) &&
                                            <SubMenu key="K12View" title="K12">
                                                {auth.allow('datap:form:k12_core') &&
                                                    <Menu.Item key="K12View">
                                                    <Link to="/k12_core">核心报表</Link>
                                                </Menu.Item>}
                                                {auth.allow('datap:form:k12_tifenbao') && 
                                                    <Menu.Item key="TifenbaoView">
                                                    <Link to="/tifenbao">提分宝</Link>
                                                </Menu.Item>}
                                                {auth.allow('datap:form:mintpie_analyse_nce') && <Menu.Item key="MintpieAnaNceView">
                                                    <Link to="/mintpie_analyse_nce">新概念</Link>
                                                </Menu.Item>}
                                                {auth.allow('datap:form:k12_cake') && <Menu.Item key="CakeView">
                                                    <Link to="/k12_cake">蛋糕</Link>
                                                </Menu.Item>}
                                            </SubMenu>}
                                    </SubMenu>
                                    
                                    {(auth.allow('datap:form:bcz_core') || auth.allow('datap:form:bcz:retention')) &&
                                        <SubMenu key="BczCore" icon={<RocketOutlined />} title="百词斩">
                                            {auth.allow('datap:form:bcz_core') &&
                                            <Menu.Item key="BczCoreView">
                                                <Link to="/bcz_core">核心报表</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:bcz:retention') && 
                                                <Menu.Item key="BczRetentionView">
                                                    <Link to="/bcz_retention">用户留存</Link>
                                                </Menu.Item>}
                                        </SubMenu>}

                                    {(auth.allow('datap:form:abroad_core') || auth.allow('datap:form:mintpie_analyse_toefl') || auth.allow('datap:form:abroad_ielts'))&&
                                        <SubMenu key="AbroadView" icon={<RiseOutlined />} title="出国">
                                            {auth.allow('datap:form:abroad_core') &&
                                                <Menu.Item key="AbroadView">
                                                <Link to="/abroad_core">总览</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:mintpie_analyse_toefl') && 
                                                <Menu.Item key="MintpieAnaToeflView">
                                                <Link to="/mintpie_analyse_toefl">托福</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:abroad_ielts') && 
                                                <Menu.Item key="AbroadIeltsView">
                                                <Link to="/abroad_ielts">雅思</Link>
                                            </Menu.Item>}
                                        </SubMenu>}

                                    {auth.prefix('datap:form:hardware_') &&
                                        <SubMenu key="HardwareView" icon={<ToolOutlined />} title="硬件">
                                            {auth.allow('datap:form:hardware_overall') &&
                                                <Menu.Item key="HardwareOverallView">
                                                <Link to="/hardware_overall">总览</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hardware_word_machine') &&
                                                <Menu.Item key="HardwareView">
                                                <Link to="/hardware_word_machine">单词机</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hardware_learn_machine') &&
                                                <Menu.Item key="LearnMachineView">
                                                <Link to="/hardware_learn_machine">扫学机</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hardware_color_machine') &&
                                                <Menu.Item key="ColorMachineView">
                                                <Link to="/hardware_color_machine">彩屏机</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hardware_dictionary_pen') &&
                                                <Menu.Item key="DictionaryPenView">
                                                <Link to="/hardware_dictionary_pen">词典笔</Link>
                                            </Menu.Item>}
                                        </SubMenu>}
                                {/* </SubMenu> */}

                                <SubMenu key="GenericForms" icon={<DotChartOutlined />} title="通用看板">
                                    {auth.allow('datap:form:universal_core') &&
                                        <Menu.Item key="UniversalCoreView">
                                            <Link to="/universal_core">百词斩流量</Link>
                                        </Menu.Item>}
                                        {auth.allow('datap:form:bcz_user_profile') &&
                                        <Menu.Item key="BczUserProfileView">
                                            <Link to="/bcz_user_profile">百词斩用户画像</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:order_query') &&
                                        <Menu.Item key="OrderQueryView">
                                            <Link to="/order_query">订单查询</Link>
                                        </Menu.Item>}
                                    {/* {auth.allow('datap:form:activity_data') &&
                                        <Menu.Item key="ActivityDataView">
                                            <Link to="/activity_data">活动数据</Link>
                                        </Menu.Item>} */}
                                    {/* {auth.allow('datap:form:course_quality') && <Menu.Item key="MintpieAnaCourselView">
                                        <Link to="/course_quality">课程质量评估监控</Link>
                                    </Menu.Item>} */}
                                    {auth.allow('datap:form:credit_data') &&
                                        <Menu.Item key="CreditDataView">
                                            <Link to="/credit_data">积分看板</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:general_monitor') &&
                                        <Menu.Item key="MonitorView">
                                            <Link to="/general_monitor">监控预警</Link>
                                        </Menu.Item>}
                                    {/* {auth.allow('datap:form:mintpie_analyse_activity_2022') && <Menu.Item key="MintpieAnaActivity2022View">
                                        <Link to="/mintpie_analyse_activity_2022">活动监控</Link>
                                    </Menu.Item>} */}

                                </SubMenu>
                                <SubMenu key="GroupReferral" icon={<LineChartOutlined />} title="导流监控">
                                    {/* {auth.allow('datap:form:full_referral') &&
                                        <Menu.Item key="FullReferralView">
                                            <Link to="/full_referral">导流全景</Link>
                                        </Menu.Item>} */}
                                    {auth.allow('datap:form:bcz_referral') &&
                                        <Menu.Item key="BczReferralView">
                                            <Link to="/bcz_referral">百词斩导流</Link>
                                        </Menu.Item>}
                                    {/* {auth.allow('datap:form:mintpie_referral') &&
                                        <Menu.Item key="MintpieReferralView">
                                            <Link to="/mintpie_referral">薄芝导流</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:ec_referral') &&
                                        <Menu.Item key="ECReferralView">
                                            <Link to="/ec_referral">私域导流</Link>
                                        </Menu.Item>} */}
                                    {auth.allow('datap:form:ad_tracing') &&
                                        <Menu.Item key="AdTracinglView">
                                            <Link to="/ad_tracing">单用户曝光价值</Link>
                                        </Menu.Item>}
                                    {auth.allow('datap:form:new_user_referral_30d') &&
                                        <Menu.Item key="NewUserReferral30DlView">
                                            <Link to="/new_user_referral_30d">导流30日LTV</Link>
                                        </Menu.Item>}
                                    {/* {auth.allow('datap:form:ad_recommend_monitor') && <Menu.Item key="AdRecommendView">
                                        <Link to="/ad_recommend_monitor">广告推荐效果监控</Link>
                                    </Menu.Item>} */}
                                </SubMenu>

                                <SubMenu key="Yuqing" icon={<GlobalOutlined />} title="市场舆情">
                                    {auth.allow('datap:form:bcz_yuqing') &&
                                        <Menu.Item key="BczYuqingView">
                                            <Link to="/bcz_yuqing">百词斩</Link>
                                        </Menu.Item>}
                                    {/* {auth.allow('datap:form:mintpie_yuqing') &&
                                        <Menu.Item key="MintpieYuqingView">
                                            <Link to="/mintpie_yuqing">薄芝</Link>
                                        </Menu.Item>} */}
                                </SubMenu>
                            </>}
                            {auth.allow('datap:form:control:no_order_monitor') &&
                                <SubMenu key="Control" icon={<LaptopOutlined />} title="内控">
                                    {auth.allow('datap:form:control:no_order_monitor') && <Menu.Item key="NoOrderMonitor">
                                        <Link to="/no_order_monitor">在课无订单监控</Link>
                                    </Menu.Item>}
                                </SubMenu>}
                            {(auth.allow('datap:form:real_product_form') ||
                                auth.allow('datap:form:trade_form') ||
                                auth.prefix('datap:form:rt_storage:'))
                                && <SubMenu key="RealProduct" icon={<ShoppingOutlined />} title="实体商品">
                                    {auth.allow('datap:form:real_product_form') && <Menu.Item key="RealProductView">
                                        <Link to="/real_product">商品综合</Link>
                                    </Menu.Item>}
                                    {auth.allow('datap:form:trade_form') && <Menu.Item key="TradeView">
                                        <Link to="/trade">履约信息</Link>
                                    </Menu.Item>}
                                    {auth.allow('datap:form:rt_storage:all') && <Menu.Item key="RtStorageAllView">
                                        <Link to="/rt_storage_all">实时库存监控</Link>
                                    </Menu.Item>}
                                    {auth.allow('datap:form:rt_storage:mintpie') && <Menu.Item key="RtStorageMintpieView">
                                        <Link to="/rt_storage_mintpie">实时库存_薄芝</Link>
                                    </Menu.Item>}
                                    {auth.allow('datap:form:rt_storage:bcz') && <Menu.Item key="RtStorageBczView">
                                        <Link to="/rt_storage_bcz">实时库存_百词斩</Link>
                                    </Menu.Item>}
                                </SubMenu>}

                            {(auth.prefix('datap:form:hr:'))
                                && <SubMenu key="HR" icon={<TeamOutlined />} title="人力用工看板">
                                    {(auth.allow('datap:form:hr:group') || auth.allow('datap:form:hr:group_cost')) &&
                                        <SubMenu key="HRGroup" title="产研-公司层">
                                             {auth.allow('datap:form:hr:group') && <Menu.Item key="hrGroupView">
                                                <Link to="/hr_group">人效指标看板</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hr:group_cost') && <Menu.Item key="hrGroupCostView">
                                                <Link to="/hr_group_cost">成本看板</Link>
                                            </Menu.Item>}
                                        </SubMenu>}

                                    {(auth.allow('datap:form:hr:bcz') ||
                                        auth.allow('datap:form:hr:adult_eng_sku') ||
                                        auth.allow('datap:form:hr:future_sku') ||
                                        auth.allow('datap:form:hr:mintpie') ||
                                        auth.allow('datap:form:hr:future_syx') ||
                                        auth.allow('datap:form:hr:abp_middle') ||
                                        auth.allow('datap:form:hr:tech_middle') ||
                                        auth.allow('datap:form:hr:data_middle') ||
                                        auth.allow('datap:form:hr:strategy_middle') ||
                                        auth.allow('datap:form:hr:chain_middle') ||
                                        auth.allow('datap:form:hr:hr') ||
                                        auth.allow('datap:form:hr:finance') ||
                                        auth.allow('datap:form:hr:legal') ||
                                        auth.allow('datap:form:hr:administration')) &&
                                        <SubMenu key="HRDepartment" title="产研-部门层">
                                             {auth.allow('datap:form:hr:bcz') && <Menu.Item key="hrBczView">
                                                <Link to="/hr_bcz">百词斩APP</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hr:adult_eng_sku') && <Menu.Item key="hrAdultEngSkuView">
                                                <Link to="/hr_adult_eng_sku">成人英语SKU研发</Link>
                                            </Menu.Item>}
                                             {auth.allow('datap:form:hr:future_sku') && <Menu.Item key="hrFutureSkuView">
                                                <Link to="/hr_future_sku">大营收多SKU研发</Link>
                                            </Menu.Item>}
                                             {auth.allow('datap:form:hr:future_syx') && <Menu.Item key="hrFutureSyxView">
                                                <Link to="/hr_future_syx">大营收多SKU市运销</Link>
                                            </Menu.Item>}
                                             {auth.allow('datap:form:hr:mintpie') && <Menu.Item key="hrFutureSyxView">
                                                <Link to="/hr_mintpie">出国市运销</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hr:abp_middle') && <Menu.Item key="hrAbpMiddleView">
                                                <Link to="/hr_abp_middle">业务平台</Link>
                                            </Menu.Item>}
                                             {auth.allow('datap:form:hr:tech_middle') && <Menu.Item key="hrTechMiddleView">
                                                <Link to="/hr_tech_middle">技术中台</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hr:chain_middle') && <Menu.Item key="hrChainMiddleView">
                                                <Link to="/hr_chain_middle">履约供应链中台</Link>
                                            </Menu.Item>}
                                             {auth.allow('datap:form:hr:hr') && <Menu.Item key="hrHrView">
                                                <Link to="/hr_hr">人力</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hr:finance') && <Menu.Item key="hrFinanceView">
                                                <Link to="/hr_finance">财务</Link>
                                            </Menu.Item>}
                                             {auth.allow('datap:form:hr:legal') && <Menu.Item key="hrLegalView">
                                                <Link to="/hr_legal">法务合规</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hr:administration') && <Menu.Item key="hrAdministrationView">
                                                <Link to="/hr_administration">行政</Link>
                                            </Menu.Item>}
                                        </SubMenu>}

                                        {(auth.allow('datap:form:hr:sales_abroad') || auth.allow('datap:form:hr:sales_fc')) &&
                                        <SubMenu key="HRSales" title="销服-销售">
                                             {auth.allow('datap:form:hr:sales_abroad') && <Menu.Item key="hrSalesAbroadView">
                                                <Link to="/hr_sales_abroad">出国</Link>
                                            </Menu.Item>}
                                            {auth.allow('datap:form:hr:sales_fc') && <Menu.Item key="hrSalesFcView">
                                                <Link to="/hr_sales_fc">大营收</Link>
                                            </Menu.Item>}
                                        </SubMenu>}
                                </SubMenu>}

                            {(auth.allow('datap:form:datap_access') || 
                             auth.allow('datap:form:ad_recommend_monitor'))
                             && <SubMenu key="PlatformMonitor" icon={<ProjectOutlined />} title="平台监控">
                                    {auth.allow('datap:form:datap_access') && <Menu.Item key="DataPAccessView">
                                    <Link to="/datap_access">数据平台监控</Link>
                                </Menu.Item>}
                                </SubMenu>}
                        </Menu>
                    </Sider>
                    <Content justify="space-around" align="middle" style={{ padding: '0 7px 0 86px', minHeight: 280 }}>
                        <Route path="/" exact render={() => <Redirect to="/group_realtime" />} />
                        {auth.allow('datap:form:bcz_core') && <Route path="/bcz_core" exact render={() => <QuickBIView pageName="百词斩核心报表" />} />}
                        {auth.allow('datap:form:mintpie_wx_app') && <Route path="/mintpie_wx_app" exact render={() => <QuickBIView pageName="薄荷芝士派公众号&app用户（流量）" />} />}
                        {auth.allow('datap:form:universal_core') && <Route path="/universal_core" exact render={() => <QuickBIView pageName="通用核心报表" />} />}
                        {auth.allow('datap:form:future_core') && <Route path="/future_core" exact render={() => <QuickBIView pageName="未来技能核心报表" />} />}
                        {auth.allow('datap:form:college_math_core') && <Route path="/college_math_core" exact render={() => <QuickBIView pageName="大学数学核心报表" />} />}
                        {auth.allow('datap:form:group_realtime') && <Route path="/group_realtime" exact render={() => <QuickBIView pageName="实时大盘" />} />}
                        {auth.allow('datap:form:group_daily') && <Route path="/group_daily" exact render={() => <QuickBIView pageName="集团日报" />} />}
                        {auth.allow('datap:form:group_weekly') && <Route path="/group_weekly" exact render={() => <QuickBIView pageName="集团周报" />} />}
                        {auth.allow('datap:form:group_monthly') && <Route path="/group_monthly" exact render={() => <QuickBIView pageName="集团月报" />} />}
                        {auth.allow('datap:form:group_year') && <Route path="/group_year" exact render={() => <QuickBIView pageName="集团年报" />} />}
                        {auth.allow('datap:form:full_referral') && <Route path="/full_referral" exact render={() => <QuickBIView pageName="导流全景" />} />}
                        {auth.allow('datap:form:bcz_referral') && <Route path="/bcz_referral" exact render={() => <QuickBIView pageName="百词斩导流" />} />}
                        {auth.allow('datap:form:mintpie_referral') && <Route path="/mintpie_referral" exact render={() => <QuickBIView pageName="薄芝导流" />} />}
                        {auth.allow('datap:form:ec_referral') && <Route path="/ec_referral" exact render={() => <QuickBIView pageName="电商私域导流" />} />}
                        {auth.allow('datap:form:ad_tracing') && <Route path="/ad_tracing" exact render={() => <QuickBIView pageName="广告追踪查询" />} />}
                        {auth.allow('datap:form:new_user_referral_30d') && <Route path="/new_user_referral_30d" exact render={() => <QuickBIView pageName="导流UE" />} />}
                        {auth.allow('datap:form:datap_access') && <Route path="/datap_access" exact render={() => <QuickBIView pageName="平台监控" />} />}
                        {auth.allow('datap:form:datap_access') && <Route path="/bi_access" exact render={() => <QuickBIView pageName="BI工具使用监控" />} />}
                        {auth.allow('datap:form:real_product_form') && <Route path="/real_product" exact render={() => <ProductView />} />}
                        {auth.allow('datap:form:trade_form') && <Route path="/trade" exact render={() => <QuickBIView pageName="实体商品-履约信息" />} />}
                        {auth.allow('datap:form:kol_monitor') && <Route path="/kol_monitor" exact render={() => <QuickBIView pageName="KOL投放监控" />} />}
                        {auth.allow('datap:form:order_query') && <Route path="/order_query" exact render={() => <QuickBIView pageName="订单查询" />} />}
                        {auth.allow('datap:form:activity_data') && <Route path="/activity_data" exact render={() => <QuickBIView pageName="活动数据" />} />}
                        {auth.allow('datap:form:rt_storage:all') && <Route path="/rt_storage_all" exact render={() => <QuickBIView pageName="实时库存监控" />} />}
                        {auth.allow('datap:form:rt_storage:mintpie') && <Route path="/rt_storage_mintpie" exact render={() => <QuickBIView pageName="实时库存_薄芝" />} />}
                        {auth.allow('datap:form:rt_storage:bcz') && <Route path="/rt_storage_bcz" exact render={() => <QuickBIView pageName="实时库存_百词斩" />} />}
                        {auth.allow('datap:form:control:no_order_monitor') && <Route path="/no_order_monitor" exact render={() => <QuickBIView pageName="内控在课无订单监控" />} />}
                        {auth.allow('datap:form:bcz_yuqing') && <Route path="/bcz_yuqing" exact render={() => <QuickBIView pageName="百词斩市场舆情" />} />}
                        {auth.allow('datap:form:mintpie_yuqing') && <Route path="/mintpie_yuqing" exact render={() => <QuickBIView pageName="薄芝市场舆情" />} />}
                        {auth.allow('datap:form:future_yuqing') && <Route path="/future_yuqing" exact render={() => <QuickBIView pageName="未来技能市场舆情" />} />}
                        {auth.allow('datap:form:ad_recommend_monitor') && <Route path="/ad_recommend_monitor" exact render={() => <QuickBIView pageName="广告推荐效果监控" />} />}
                        {auth.allow('datap:form:bcz:retention') && <Route path="/bcz_retention" exact render={() => <QuickBIView pageName="百词斩核心报表_用户留存" />} />}
                        {auth.allow('datap:form:hr:group') && <Route path="/hr_group" exact render={() => <QuickBIView pageName="公司层人力用工看板_人数" />} />}
                        {auth.allow('datap:form:hr:group_cost') && <Route path="/hr_group_cost" exact render={() => <QuickBIView pageName="公司层人力用工看板_成本" />} />}
                        {auth.allow('datap:form:hr:bcz') && <Route path="/hr_bcz" exact render={() => <QuickBIView pageName="百词斩APP用工看板" />} />}
                        {auth.allow('datap:form:hr:adult_eng_sku') && <Route path="/hr_adult_eng_sku" exact render={() => <QuickBIView pageName="成人英语SKU研发用工看板" />} />}
                        {auth.allow('datap:form:hr:future_sku') && <Route path="/hr_future_sku" exact render={() => <QuickBIView pageName="未来技能SKU研发用工看板" />} />}
                        {auth.allow('datap:form:hr:mintpie') && <Route path="/hr_mintpie" exact render={() => <QuickBIView pageName="出国市运销用工看板" />} />}
                        {auth.allow('datap:form:hr:future_syx') && <Route path="/hr_future_syx" exact render={() => <QuickBIView pageName="大营收多SKU市运销用工看板" />} />}
                        {auth.allow('datap:form:hr:abp_middle') && <Route path="/hr_abp_middle" exact render={() => <QuickBIView pageName="业务平台用工看板" />} />}
                        {auth.allow('datap:form:hr:tech_middle') && <Route path="/hr_tech_middle" exact render={() => <QuickBIView pageName="技术中台用工看板" />} />}
                        {auth.allow('datap:form:hr:data_middle') && <Route path="/hr_data_middle" exact render={() => <QuickBIView pageName="数据中台用工看板" />} />}
                        {auth.allow('datap:form:hr:strategy_middle') && <Route path="/hr_strategy_middle" exact render={() => <QuickBIView pageName="战略中台用工看板" />} />}
                        {auth.allow('datap:form:hr:chain_middle') && <Route path="/hr_chain_middle" exact render={() => <QuickBIView pageName="履约供应链中台用工看板" />} />}
                        {auth.allow('datap:form:hr:hr') && <Route path="/hr_hr" exact render={() => <QuickBIView pageName="人力用工看板" />} />}
                        {auth.allow('datap:form:hr:finance') && <Route path="/hr_finance" exact render={() => <QuickBIView pageName="财务用工看板" />} />}
                        {auth.allow('datap:form:hr:legal') && <Route path="/hr_legal" exact render={() => <QuickBIView pageName="法务合规用工看板" />} />}
                        {auth.allow('datap:form:hr:administration') && <Route path="/hr_administration" exact render={() => <QuickBIView pageName="行政用工看板" />} />}
                        {auth.allow('datap:form:hr:poc') && <Route path="/hr_poc" exact render={() => <QuickBIView pageName="产品导向SKU研发用工看板" />} />}
                        {auth.allow('datap:form:mintpie_analyse_sale') && <Route path="/mintpie_analyse_sale" exact render={() => <QuickBIView pageName="薄芝_核心经营" />} />}
                        {auth.allow('datap:form:mintpie_analyse_self_flow') && <Route path="/mintpie_analyse_self_flow" exact render={() => <QuickBIView pageName="薄芝_自有流量" />} />}
                        {auth.allow('datap:form:mintpie_analyse_activity_2022') && <Route path="/mintpie_analyse_activity_2022" exact render={() => <QuickBIView pageName="薄芝_2022活动监控" />} />}
                        {auth.allow('datap:form:mintpie_analyse_nce') && <Route path="/mintpie_analyse_nce" exact render={() => <QuickBIView pageName="薄芝_新概念" />} />}
                        {auth.allow('datap:form:mintpie_analyse_toefl') && <Route path="/mintpie_analyse_toefl" exact render={() => <QuickBIView pageName="薄芝_托福" />} />}
                        {auth.allow('datap:form:sku_satisfaction') && <Route path="/sku_satisfaction" exact render={() => <QuickBIView pageName="SKU用户满意度" />} />}
                        {auth.allow('datap:form:credit_data') && <Route path="/credit_data" exact render={() => <QuickBIView pageName="积分看板" />} />}
                        {auth.allow('datap:form:mintpie_analyse_tomato') && <Route path="/mintpie_analyse_tomato" exact render={() => <QuickBIView pageName="薄芝_番茄" />} />}
                        {auth.allow('datap:form:course_quality') && <Route path="/course_quality" exact render={() => <QuickBIView pageName="课程质量评估监控" />} />}
                        {auth.allow('datap:form:adult_english') && <Route path="/adult_english" exact render={() => <QuickBIView pageName="大学及成人英语" />} />}
                        {auth.allow('datap:form:bcz_user_profile') && <Route path="/bcz_user_profile" exact render={() => <QuickBIView pageName="百词斩用户画像" />} />}
                        {auth.allow('datap:form:k12_tifenbao') && <Route path="/tifenbao" exact render={() => <QuickBIView pageName="提分宝核心报表" />} />}
                        {auth.allow('datap:form:abroad_ielts') && <Route path="/abroad_ielts" exact render={() => <QuickBIView pageName="出国_雅思" />} />}
                        {auth.allow('datap:form:hardware_word_machine') && <Route path="/hardware_word_machine" exact render={() => <QuickBIView pageName="单词机核心报表" />} />}
                        {auth.allow('datap:form:general_monitor') && <Route path="/general_monitor" exact render={() => <QuickBIView pageName="监控预警" />} />}
                        {auth.allow('datap:form:fc_overview') && <Route path="/fc_overview" exact render={() => <QuickBIView pageName="大营收多SKU总览" />} />}
                        {auth.allow('datap:form:k12_core') && <Route path="/k12_core" exact render={() => <QuickBIView pageName="K12核心报表" />} />}
                        {auth.allow('datap:form:abroad_core') && <Route path="/abroad_core" exact render={() => <QuickBIView pageName="出国核心报表" />} />}
                        {auth.allow('datap:form:k12_cake') && <Route path="/k12_cake" exact render={() => <QuickBIView pageName="蛋糕核心报表" />} />}
                        {auth.allow('datap:form:hardware_dictionary_pen') && <Route path="/hardware_dictionary_pen" exact render={() => <QuickBIView pageName="词典笔核心报表" />} />}
                        {auth.allow('datap:form:hardware_learn_machine') && <Route path="/hardware_learn_machine" exact render={() => <QuickBIView pageName="扫学机核心报表" />} />}
                        {auth.allow('datap:form:hardware_overall') && <Route path="/hardware_overall" exact render={() => <QuickBIView pageName="硬件总览看板" />} />}
                        {auth.allow('datap:form:hr:sales_abroad') && <Route path="/hr_sales_abroad" exact render={() => <QuickBIView pageName="出国销售用工看板" />} />}
                        {auth.allow('datap:form:hr:sales_fc') && <Route path="/hr_sales_fc" exact render={() => <QuickBIView pageName="大营收销售用工看板" />} />}
                        {auth.allow('datap:form:newreading_core') && <Route path="/newreading_core" exact render={() => <QuickBIView pageName="新阅读核心看板" />} />}
                        {auth.allow('datap:form:hardware_color_machine') && <Route path="/hardware_color_machine" exact render={() => <QuickBIView pageName="彩屏单词机核心看板" />} />}
                    </Content>
                </Layout>
            </Router>
        );
    }
}

// <Route path="/" exact component={FormView} />

export default FormView;